<h2 mat-dialog-title>{{banner}}</h2>
<mat-dialog-content>
    <div style="width:400px;">
        <div *ngIf="!statusHistory">
            <div style="padding-bottom: 10px;">
                <span>{{infoLine}}</span>
            </div>
            <div style="padding-bottom: 10px;">
                <span>{{commentHeader}}</span>
            </div>
        </div>
        <div *ngIf="statusHistory">
            <div style="padding-bottom: 10px;">
                <span>{{statusHistory.CreatedOn | date:'MM/dd/yy hh:mm a'}}&nbsp;&nbsp;{{statusHistory.Status}}</span>
            </div>
        </div>
        <tyl-form-field style="width:100%;" label="Comments"
            hint="{{1000 - (comment ? comment.length : 0)}} characters left">
            <textarea matInput [(ngModel)]="comment" maxlength="1000" rows="6" style="resize:none"></textarea>
        </tyl-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>

    </div>
    <div class='flex-footer-right'>
        <tyl-button *ngIf="markType == 'Re-Open'" image="Checkmark.png" label="Re-Open" (clickEvent)="saveClick()">
        </tyl-button>
        <tyl-button *ngIf="emailNext && markType == 'Re-Open'" image="next arrow.png" label="Re-Open and Send Email"
            (clickEvent)="nextClick()"></tyl-button>
        <tyl-button *ngIf="newStatus == 'Rejected'" image="Checkmark.png" label="Reject" (clickEvent)="saveClick()">
        </tyl-button>
        <tyl-button *ngIf="emailNext && newStatus == 'Rejected'" image="next arrow.png" label="Reject and Send Email"
            (clickEvent)="nextClick()"></tyl-button>
        <tyl-button *ngIf="emailNext && newStatus != 'Rejected' && markType != 'Re-Open'" image="next arrow.png"
            label="Next" (clickEvent)="nextClick()"></tyl-button>
        <tyl-button *ngIf="!emailNext" image="Checkmark.png" label="OK" (clickEvent)="saveClick()"></tyl-button>
        <tyl-button image="cancel.png" label="Cancel" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>